<!-- 欠费待补交列表 -->
<template>
  <div class="fee-owe-list" data-test="fee-owe-list">
    <search-filter-new
      :campus="params.campusList"
      :items="searchItems"
      placeholder="请输入姓名"
      @onCampus="chooseCampus"
      @onSearch="params.studentName = $event"
      @onSetting="showRules"
      @onBatch="isBatch = true"
    />
    <search-filter-new @change="filterChange">
      <filter-item
        kind="yq-提醒"
        title="1213123"
        :value="this.params.noticeStatus"
        keyName="noticeStatus"
        :multiple="true"
      >
      </filter-item>

      <filter-item
        class="justify-right"
        :hasFilter="!!params.noticeStatus.length"
        keyName="noticeStatus"
        :value="params.noticeStatus"
        kind="yq-通用选择"
        title="提醒状态"
        :list="[
          { text: '已提醒', value: 1 },
          { text: '未提醒', value: 0 },
        ]"
      />

      <div
        class="shortcut-item has-down-icon"
        :class="{ 'has-filter': params.belongerIdList.length }"
        @click="chooseTeacher"
      >
        业绩归属人
      </div>
      <sideFilterItem :hasFilter="hasFilter" @clickFilter="openFilter" />
    </search-filter-new>
    <div class="list-number-line" v-if="list.length">
      <div class="add-area__info">待补交数量：{{ total }}</div>
    </div>
    <vx-list class="wrapper" enable :api="api" :params="params" @load="onLoad" ref="listScroller">
      <div class="item" v-for="item in list" :key="item.id" @click="opStudent(item)">
        <div v-if="isBatch">
          <van-checkbox v-model="item.checked" icon-size="var(--fs-ex1)" class="check-icon" />
        </div>
        <div class="item-content">
          <div class="item-top van-hairline--bottom">
            <div class="item-t1 flex-between">
              <span class="name">{{ item.buyerName }}</span>
              <van-icon name="ellipsis" class="op-img" v-if="!isBatch" />
            </div>
            <div class="item-t2 van-ellipsis">{{ item.alias }}</div>
          </div>
          <div class="item-info flex-between">
            <div class="lb">订单金额</div>
            <div class="ve van-ellipsis">￥{{ item.orderMoney | formatNumber}}</div>
          </div>
          <div class="item-info flex-between">
            <div class="lb">创建时间</div>
            <div class="ve van-ellipsis">
              {{ item.orderCreateTime | formatDatetime('yyyy-MM-dd hh:mm') }} {{ item.ordererName }}
            </div>
          </div>
          <div class="item-info flex-between">
            <div class="lb">业绩归属人</div>
            <div class="ve van-ellipsis">
              {{
                item.belongerNameList && item.belongerNameList.length > 0
                  ? item.belongerNameList.join('，')
                  : '-'
              }}
            </div>
          </div>
          <div class="item-info flex-between">
            <div class="lb">上次提醒时间</div>
            <div class="ve van-ellipsis">
              {{
                item.lastNoticeTime
                  ? app.tool.date.formatDatetime(item.lastNoticeTime, 'yyyy-MM-dd hh:mm')
                  : '-'
              }}
              {{
                item.lastNoticeTime
                  ? item.lastNoticeOperatorName
                    ? item.lastNoticeOperatorName
                    : '自动提醒'
                  : ''
              }}
            </div>
          </div>
          <div class="item-bottom flex-between van-hairline--top">
            <div>
              <div>
                下次补交日期：{{
                  item.nextPayTime
                    ? app.tool.date.formatDatetime(item.nextPayTime, 'yyyy-MM-dd')
                    : '-'
                }}
              </div>
              <div class="owe">
                欠费：<span class="tag"
                  >¥ <span class="price">{{ item.oweFeeMoney | formatNumber }}</span></span
                >
              </div>
            </div>
            <van-button
              square
              round
              type="primary"
              size="small"
              v-if="!isBatch"
              @click.stop="toCollectMoney(item)"
              >去收款</van-button
            >
          </div>
        </div>
      </div>
      <van-empty
        image="https://cdn01.xiaogj.com/uploads/x3/assets/m/img/tips/empty.png"
        description="没有找到学员哦～"
        v-if="(!list || (list && list.length === 0)) && !loading"
        image-size="128"
        style="padding-top: calc(var(--gap) * 50)"
      ></van-empty>
    </vx-list>

    <div class="footer" v-if="isBatch">
      <div class="choosed-status">
        <div class="checked-nav" :class="{ 'all-checked': allChecked }">
          <van-checkbox
            v-model="allChecked"
            icon-size="var(--fs-lg)"
          />全选
        </div>
        <!-- <span class="choosed-num" >已选:<span>{{choosedNum}}</span></span> -->
      </div>
      <van-button
        class="ccbtn"
        square
        round
        @click="isBatch = false"
        style="
          margin-right: calc(var(--gap) * 12);
          min-width: calc(var(--gap) * 72);
          white-space: nowrap;
        "
      >
        取消
      </van-button>
      <van-button
        class="cnbtn"
        square
        round
        block
        type="primary"
        @click="send"
        data-test="fee-owe-list-btn-send"
      >
        发送补交提醒({{ choosedList.length }}/{{ total }})
      </van-button>
    </div>

    <!-- 操作的弹窗 -->
    <van-action-sheet
      v-model="showOpMark"
      :actions="opMarkActions"
      cancel-text="取消"
      close-on-click-action
      @cancel="showOpMark = false"
      @select="onSelectOpMark"
      :description="currentOp.studentName"
    />
  </div>
</template>

<script>
import SearchFilterNew from '@x3/vue/comp/search-filter-new.vue';
import FilterItem from '@x3/vue/comp/filter-item.vue';
import sideFilterItem from '@x3/vue/filter-comps/side-filter.vue';
import { openFeeOweFiltrate } from './filtrate/index.js';

export default {
  components: {
    SearchFilterNew,
    FilterItem,
    sideFilterItem,
  },
  data() {
    return {
      pageTitle: '欠费待补交',
      api: this.$api.findFeeOwePage,
      params: {
        studentName: '',
        // 校区ids
        campusIds: [],
        campusList: [],
        // 创建人
        orderCreatePersonIdList: [],
        orderCreatePersonLists: [],
        // 业绩归属人
        belongerIdList: [],
        belongerLists: [],
        // 下次补交日期
        nextPayStartTime: '',
        nextPayEndTime: '',
        // 创建时间
        orderCreateStartTime: '',
        orderCreateEndTime: '',
        // 上次提醒时间
        lastNoticeStartTime: '',
        lastNoticeEndTime: '',
        noticeStatus: [],
      },
      list: [],
      total: 0,
      loading: true,
      isBatch: false,
      showOpMark: false,
      isSubmit: false,
      currentOp: {},
    };
  },
  computed: {
    // 当前是否有筛选
    hasFilter: function () {
      let len1 = this.params.orderCreatePersonIdList.length;
      let len2 = this.params.belongerIdList.length;
      let len3 = this.params.noticeStatus.length;
      let len = len1 + len2 + len3;
      if (len > 0) {
        return true;
      } else if (
        this.params.nextPayStartTime ||
        this.params.nextPayEndTime ||
        this.params.orderCreateStartTime ||
        this.params.orderCreateEndTime ||
        this.params.lastNoticeStartTime ||
        this.params.lastNoticeEndTime
      ) {
        return true;
      } else {
        return false;
      }
    },
    choosedList() {
      return this.list.filter(v => v.checked);
    },
    opMarkActions() {
      let actions = [];
      if (app.permission.op('send_fee_owe_notice')) {
        actions.push({ name: '发送补交提醒', id: 0 });
      }
      actions.push({ name: '查看订单详情', id: 1 });
      if (app.permission.op('edit_order')) {
        actions.push({ name: '编辑下次补交日期', id: 2 });
      }
      return actions;
    },
    choosedNum() {
      return this.choosedList.length;
    },
    allChecked: {
      get() {
        return this.choosedNum === this.list.length;
      },
      set(v) {
        this.allCheckBoxChange(v);
      },
    },
    searchItems() {
      let arr = ['campus', 'search'];
      if (app.permission.op('auto_fee_owe_rule')) {
        arr.push('setting');
      }
      if (app.permission.op('send_fee_owe_notice') && !this.isBatch) {
        arr.push('batch');
      }
      return arr;
    },
  },
  methods: {
    filterChange(data) {
      Object.assign(this.params, data);
    },
    onLoad(list, res) {
      this.list = list;
      this.total = res && res.page && res.page.totalCount;
      this.loading = false;
      vant.Toast.clear();
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        ids: this.params.campusIds,
        list: this.params.campusList,
      });
      this.params.campusIds = res.ids;
      this.params.campusList = res.list;
    },
    // 选择业绩归属人
    async chooseTeacher() {
      let res = await app.x3.side.xsTeacher({
        ids: this.params.belongerIdList,
        list: this.params.belongerLists,
      });

      this.params.belongerIdList = res.ids;
      this.params.belongerLists = res.list;
    },
    // 打开筛选
    async openFilter() {
      let res = await openFeeOweFiltrate({
        params: {
          ...this.params,
        },
      });
      this.showLoading();
      this.params = {
        studentName: this.params.studentName,
        campusIds: this.params.campusIds,
        campusList: this.params.campusList,
        ...res.params,
      };
    },
    opStudent(item) {
      if (this.isBatch) {
        this.$set(item, 'checked', !Boolean(item.checked));
      } else {
        this.showOpMark = true;
        this.currentOp = item;
      }
    },
    onSelectOpMark(val) {
      //操作选择
      switch (val.id) {
        case 0: //发送欠交提醒
          this.send();
          break;
        case 1: //查看订单详情
          this.$router.push(
            `/orderDetail/${this.currentOp.orderId}/${this.currentOp.orderType}/${this.currentOp.sourceType}`
          );
          break;
        case 2: //编辑下次补交日期
          this.updateNextPayTime();
          break;
        default:
          break;
      }
    },
    cancelBatch() {
      this.isBatch = false;
      this.list.forEach(v => {
        this.$set(v, 'checked', false);
      });
    },
    toCollectMoney(item) {
      this.$router.push(`/sf2/${item.orderId}`);
    },
    send() {
      let receiver = this.isBatch ? this.choosedList : [this.currentOp];
      if (receiver.length == 0) {
        this.$toast.fail('请选择要发送补交提醒的学员');
        return;
      }
      this.$router.push({
        name: 'feeOweSend',
        params: {
          receiver: receiver,
        },
      });
    },
    allCheckBoxChange(val) {
      this.list.forEach(v => {
        this.$set(v, 'checked', val);
      });
    },
    showRules() {
      this.$router.push('./feeOweRules');
    },
    async updateNextPayTime() {
      let res = await app.x3.picker.calendar({
        defaultDate: this.currentOp.nextPayTime ? new Date(this.currentOp.nextPayTime) : new Date(),
        maxDate: new Date(2030, 12, 31),
      });
      let nextPayTime = res.getTime();
      await this.update({
        type: 2,
        nextPayTime: nextPayTime,
      });
    },
    // 更新下次补交日期或内外备注
    async update(params) {
      await this.$api.editOrderNotesAndNextPayTime({
        studentId: this.currentOp.buyerId,
        orderId: this.currentOp.orderId,
        ...params,
      });
      this.hightRefreshFun();
    },
    hightRefreshFun() {
      this.$refs['listScroller'] && this.$refs['listScroller'].hightReFresh();
    },
  },
  created() {
    this.$onBus('update-order-detail-success', this.hightRefreshFun);
    this.$onBus('refresh-fee-owe-list', () => {
      this.showLoading();
      this.$refs.listScroller.refresh();
    });

    // 首页待办进来
    if (this.$route.params && this.$route.params.isFromTodo) {
      if (this.$route.params.isFromTodo == '1') {
        this.params.nextPayStartTime = this.params.nextPayEndTime = app.tool.date.formatDatetime(new Date(), 'yyyy-MM-dd');
      } else {
        this.params.nextPayStartTime = '2020-01-01';
        const date = new Date();
        date.setDate(date.getDate() - 1);
        this.params.nextPayEndTime = app.tool.date.formatDatetime(date, 'yyyy-MM-dd');
      }
      this.params.belongerIdList = [app.teacher.user.id];
      this.params.belongerLists = [{
        id: app.teacher.user.id,
        name: app.teacher.user.name,
      }]
    }
  },
};
</script>

<style lang="scss" scoped>
.fee-owe-list {
  display: flex;
  flex-direction: column;

  .wrapper {
    flex: 1;
    overflow-y: auto;
    .item {
      display: flex;
      justify-content: space-between;
      background-color: var(--white);
      border-radius: var(--radius-sm);
      margin: 0 calc(var(--gap) * 16) calc(var(--gap) * 12) calc(var(--gap) * 16);
      padding: calc(var(--gap) * 12) calc(var(--gap) * 16);
      .check-icon {
        flex-shrink: 0;
        margin-right: calc(var(--gap) * 16);
      }
      .item-content {
        flex: 1;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        overflow: hidden;
        .item-top {
          padding-bottom: calc(var(--gap) * 12);
          .item-t1 {
            .name {
              font-size: var(--fs-lg);
              line-height: var(--lh-lg);
              color: var(--g8);
              font-weight: var(--bold);
            }
            .op-img {
              font-size: var(--fs-ex2);
              margin-left: calc(var(--gap) * 11);
              vertical-align: middle;
            }
          }
          .item-t2 {
            margin-top: calc(var(--gap) * 10);
            font-size: var(--fs-md);
            line-height: var(--lh-md);
            color: var(--g7);
          }
        }
        .item-info {
          margin-top: calc(var(--gap) * 6);
          .lb {
            margin-right: calc(var(--gap) * 16);
            color: var(--g6);
            flex-shrink: 0;
          }
          .ve {
            color: var(--g7);
          }
        }
        .item-bottom {
          margin-top: calc(var(--gap) * 8);
          padding-top: calc(var(--gap) * 12);
          color: var(--g7);
          .owe {
            margin-top: calc(var(--gap) * 6);
            .tag {
              color: var(--c3);
              .price {
                font-size: var(--fs-ex1);
                line-height: var(--lh-ex1);
              }
            }
          }
        }
      }
    }
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .van-button {
      min-width: 20px;
      height: calc(var(--w) * 40);
      padding: 0 8px;
    }
    .ccbtn {
      flex: 2;
    }
    .cnbtn {
      flex: 5;
    }
    .choosed-status {
      flex: 1;
      white-space: nowrap;
      margin-right: calc(var(--gap) * 16);

      .checked-nav {
        margin-right: calc(var(--gap) * 16);
        display: flex;
        align-items: center;
        color: var(--g6);
        > div {
          margin-right: calc(var(--gap) * 4);
        }
        &.all-checked {
          color: var(--g8);
        }
      }
    }    
  }
}
</style>